/**
 * 1. DOM结构 与 Vue指令 (若无<span>子元素，children[0].cloneNode会报错)
 * <div>定宽 --> <p>不可折行 --> 文本内容必须由<span>包裹
 * <div style="width:100px;overflow:hidden;">
 *   <p v-marquee>
 *    <span>demodemodemo</span>
 *   </p>
 * </div>
 * 2. marquee-class 类名 ( 定义在 animation.scss )
 *    textloop 动画名称
 *    textloopar 针对阿拉伯语的动画名称 --> 使用时<div>上必须有 direction:rtl; 属性设置
 *
*/
import Vue from 'vue'
Vue.directive('marquee', function (el) {
  if (el.children.length === 2) {
    el.classList.remove('marquee-class')
    el.removeChild(el.children[1])
  }
  if (el.classList.contains('marquee-class')) return
  el.style.cssText += 'white-space:nowrap;'
  window.setTimeout(() => {
    let offsetWidth = el.offsetWidth
    let scrollWidth = el.scrollWidth
    if (offsetWidth && scrollWidth && (scrollWidth > offsetWidth)) {
      let clone = el.children[0].cloneNode(true) // 复制一次 <span> 子元素
      el.appendChild(clone)
      el.style.cssText += `;-webkit-animation-duration:${scrollWidth / 20}s;animation-duration:${scrollWidth / 20}s;--offset:${offsetWidth - scrollWidth * 2 - 20}px`
      el.classList.add('marquee-class')
    }
  }, 20)
})



// WEBPACK FOOTER //
// ./src/directives/index.js